const carousels = [].slice.call(document.querySelectorAll('.swiper-container'))

carousels.forEach((carousel, index) => {
  /* setup support for multiple sliders on page */

  // configure custom classes to allow multi-swiper instances on same page
  let sliderIndex = 'swiper-container-s' + index
  let paginationIndex = 'swiper-pagination-s' + index
  let buttonNextIndex = 'swiper-button-next-s' + index
  let buttonPrevIndex = 'swiper-button-prev-s' + index
  let sliderWrapper = carousel.parentElement

  // grab the child elements that we need to add custom classes to
  let pagination = sliderWrapper.querySelector('.swiper-pagination')
  let buttonNext = sliderWrapper.querySelector('.swiper-button-next')
  let buttonPrev = sliderWrapper.querySelector('.swiper-button-prev')

  // adding custom classes
  carousel.classList.add(sliderIndex)
  pagination.classList.add(paginationIndex)
  buttonNext.classList.add(buttonNextIndex)
  buttonPrev.classList.add(buttonPrevIndex)

  // setup default params and allow for overrides based on data-carousel-params attribute
  let params = Object.assign(
    {},
    {
      loop: true,
      slidesPerView: 1.1,
      spaceBetween: 16,
      pagination: {
        el: `.${paginationIndex}`,
        clickable: true
      },
      navigation: {
        nextEl: `.${buttonNextIndex}`,
        prevEl: `.${buttonPrevIndex}`
      },
      breakpoints: {
        599: {
          slidesPerView: 1
        }
      }
    },
    JSON.parse(carousel.getAttribute('data-carousel-params') || '{}')
  )

  // Use indexed selector to allow multi-swiper instances on same page
  // eslint-disable-next-line no-undef
  new Swiper(`.${sliderIndex}`, params)
})
